import { ActionType, getType } from 'typesafe-actions';

import * as currentOrderActions from '../../actionCreators/currentOrder';

const initialState = null;

export default function (
  state: string | null = initialState,
  action: ActionType<typeof currentOrderActions>,
): string | null {
  switch (action.type) {
    case getType(currentOrderActions.setEtag): {
      const { value } = action.payload;
      return value == null ? initialState : value;
    }
    default:
      return state;
  }
}
